import ListFiltersListLayout from './ListFiltersListLayout';
import StaticFiltersListLayout from './StaticFiltersListLayout';
import QuickFiltersLayout from './QuickFiltersLayout';
import useFiltersLayoutHelper from '../useFiltersLayoutHelper';
import { FiltersLayoutProps } from '../types';
import { useUiTheme } from 'framework/uiTheme';
import { Button } from '../../../../ui/mui-builder/Button/Button';
import { Box } from '@mui/material';

interface ListFiltersLayoutProps extends FiltersLayoutProps {
  isApplied?: boolean;
  showAsIcon?: boolean;
}

const ListFiltersLayout = ({
  isApplied = false,
  quickFilters,
  children,
  showAsIcon = false,
}: ListFiltersLayoutProps) => {
  const {
    getFilterItems,
    toggleElement,
    clear,
    getSelectedFilterItems,
    isStatic = false,
  } = useFiltersLayoutHelper({
    children,
  });
  const { Button: ThemedButton = Button } = useUiTheme();
  const ListLayout = isStatic ? StaticFiltersListLayout : ListFiltersListLayout;

  return (
    <>
      <QuickFiltersLayout>{quickFilters}</QuickFiltersLayout>
      <ListLayout
        selectedFilters={getSelectedFilterItems()}
        filters={getFilterItems()}
        toggleFilter={toggleElement}
        showAsIcon={showAsIcon}
      />

      {isApplied && (
        <Box
          className="filters-reset-btn"
          sx={{
            display: 'inline-flex',
            marginBottom: '12px',
            verticalAlign: 'inherit',
            '& > button': {
              padding: '3px 7px',
              minHeight: '31px',
              minWidth: '30px',
            },
          }}
        >
          <ThemedButton variant="text" onClick={clear}>
            Reset
          </ThemedButton>
        </Box>
      )}
    </>
  );
};

export default ListFiltersLayout;
